import React, { useState, useMemo, useEffect } from "react";
import { Button } from "@/components/ui/button";
import { ChevronLeft, ChevronRight } from "lucide-react";

export function usePaged(rows, perPage = 10) {
  const [page, setPage] = useState(1);
  const total = rows.length;
  const totalPages = Math.max(1, Math.ceil(total / perPage));
  useEffect(() => { if (page > totalPages) setPage(1); }, [totalPages, page]);
  const pageRows = useMemo(
    () => rows.slice((page - 1) * perPage, page * perPage),
    [rows, page, perPage]
  );
  return { page, setPage, totalPages, pageRows, total, perPage };
}

export const Pager = ({ page, setPage, totalPages, total, perPage }) => {
  if (total <= perPage) return null;
  const from = (page - 1) * perPage + 1;
  const to = Math.min(page * perPage, total);
  const start = Math.max(1, Math.min(page - 2, totalPages - 4));
  const end = Math.min(totalPages, start + 4);
  const nums = [];
  for (let i = start; i <= end; i++) nums.push(i);
  return (
    <div className="flex flex-wrap items-center justify-between gap-3 px-4 py-3 border-t border-stone-200" data-testid="pager">
      <p className="text-xs text-stone-500">Menampilkan <b className="text-stone-700">{from}–{to}</b> dari <b className="text-stone-700">{total}</b></p>
      <div className="flex items-center gap-1">
        <Button size="sm" variant="outline" disabled={page <= 1} onClick={() => setPage(page - 1)} data-testid="pager-prev" className="rounded-lg h-8 px-2">
          <ChevronLeft size={16} />
        </Button>
        {start > 1 && <span className="px-1 text-stone-400 text-sm">…</span>}
        {nums.map((n) => (
          <Button key={n} size="sm" variant={n === page ? "default" : "outline"} onClick={() => setPage(n)} data-testid={`pager-page-${n}`}
            className={`rounded-lg h-8 w-8 p-0 ${n === page ? "bg-emerald-600 hover:bg-emerald-700" : ""}`}>
            {n}
          </Button>
        ))}
        {end < totalPages && <span className="px-1 text-stone-400 text-sm">…</span>}
        <Button size="sm" variant="outline" disabled={page >= totalPages} onClick={() => setPage(page + 1)} data-testid="pager-next" className="rounded-lg h-8 px-2">
          <ChevronRight size={16} />
        </Button>
      </div>
    </div>
  );
};
